//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "GeneralSearchCountryTableRow",
  props: {
    service: {
      type: Object,
      default: () => ({})
    },
    dataType: {
      type: String,
      default: '',
    },
    isVisibleNewFunction: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getLink() {
      return this.dataType === 'country' ? `/${this.service.service_slug}` : `/countries/${this.service.country_slug}`;
    },
    getCurrency() {
      return this.$store.getters["currency/currentCurrency"];
    },

    conversionSms: function () {
      if (this.service?.conversion_sms === "") {
        return "< 5 %"
      }
      return Number(this.service?.conversion_sms) <= 5 ? '< 5 %' : `${this.service?.conversion_sms} %`
    },
    // перестали выводить, если без надобности, то удаляем
    // conversionNumber: function () {
    //   if (this.service?.conversion_number === "") {
    //     return "-"
    //   }
    //   return this.service?.conversion_number
    // },
    // conversionActivation: function () {
    //   if (this.service?.conversion_activation === "") {
    //     return "-"
    //   }
    //   return this.service?.conversion_activation
    // },
  },
  methods: {
    countLanguages(count = 0) {

      if (count <= 0) {
        return this.$t('servicesList.quantityFew')
      }

      return [
        count,
        this.$t('servicesList.quantity')
      ].join(" ")
    },
  },
}
